import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms'

@Component({
  selector: 'form-input-textarea',
  templateUrl: './form-input-textarea.component.html',
  styleUrls: ['./form-input-textarea.component.scss']
})
export class FormInputTextareaComponent implements OnInit {


  @Input() descricao: String;

  @Input() nameControl: String;

  @Input() validador: AbstractControl;

  @Input() form: FormGroup;

  @Input() obrigatorio: boolean = false;

  @Output("valor") valorAlterado: EventEmitter<string> = new EventEmitter<string>();

  public valorCampo: string;


  @Input()
  get valor() {
    if (this.valorCampo) {
      this.valorCampo = this.valorCampo.trim();
    } else {
      this.valorCampo = null;
    }

    return this.valorCampo;
  }

  set valor(valor) {
    if (valor) {
      this.valorCampo = valor.trim();
    } else {
      this.valorCampo = null;
    }
    this.valorAlterado.emit(this.valorCampo);
  }

  ngOnInit() {

    Object.keys(this.form.controls).forEach(control => {
      if (control == this.nameControl) {
        this.validador = this.form.controls[control];
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/form-input-textarea/form-input-textarea.component.ts